// AI内製化支援（/enablement）の LP の文言。
// 出典: 営業_AI内製化支援のご紹介 v0.1（2026年10月）と、営業_内製化支援_提案テンプレート 01〜04 v0.4（汎用の提案書。
// 2026-10-20 代表指示で v0.2 から v0.4 に変えた。毎週の講義とハンズオンは対面と書く）。
// 各ブロックのコメントに資料のページを残す。資料にない数字・実績・顧客名は足さない。料金は書かない（2026-10-20 代表指示）。
// 2026-10-20 代表指示: 内製化支援プログラムの成果は2つ。人が育つことと、実際に使われるユースケースができ、実装まで進むこと
// （ユースケースづくりは研修とほぼ並行して進め、SALT2が伴走し、手は貴社の方が動かす。投資の回収はここから生まれる）。
// 2026-10-17・18 代表指示: LP は上から順に「どんな支援があるか」を読ませ、事例は各プログラムの中に置く
// （事例とプログラムを分けない）。困りごとからプランを見つけるのは、別のページ（/enablement/plan。src/data/enablementPlan.js）。

export const PLAN_PATH = '/enablement/plan';

// ヒーロー（資料 p.3「OUR GOAL」と、採用資料 p.18）
export const hero = {
  label: 'Enablement — 法人向けAI内製化支援',
  ghost: 'ENABLEMENT',
  // 行の中はフレーズの配列（狭い画面でもフレーズの境目でだけ折り返す）
  heading: [['企業が、', '自らAIで'], ['仕事を', '変えられるように。']],
  // 資料 p.3（研修で終わらせず、選んだ人が自分で作り切り、作り続けられる状態）／2026-10-20 代表指示（2つの成果）
  lead: '研修で終わらせず、2つの成果を目指します。選んだ人が、自分で作り続けられるように育つこと。そして、貴社の方が、実際の業務で使われるユースケースを作り、実装まで進めることです。',
  primaryCta: '資料請求',
  planCta: '貴社に合うプランを見つける',
  image: {
    src: '/img/architecture/blue/p04-blue-inset-ramp.jpg',
    alt: 'ブルーの開口部へ向かってのぼるコンクリートのスロープ',
  },
};

// 事例（資料 p.17〜18 と、2026-10-20 代表の回答）。顧客名は資料どおりの匿名表記。どのプログラムの事例かは programs と enablementPlan.js で指す。
// 大手総合商社（資料では「大手商社C社」）は、AIコンサルティング・開発の事例1（/cases/case-1。data/consulting.js）と同じ会社なので、
// 同じ「大手総合商社」と書き、その事例へつなぐ（2026-10-20 代表指示。中身は consulting.js の case-1 の事実だけ）
export const cases = {
  'maker-a': {
    id: 'maker-a',
    name: '大手メーカーA社',
    who: '東証プライム上場のBtoCメーカー',
    scope: 'マネージャー層7名（非エンジニアが中心）・2か月',
    // 2026-10-20 代表の回答: 7名が1人1つずつ7つのアプリを作り、そのうち2つが本番化に進んでいる。次の取り組み（AIエージェント研修、
    // 新たに6名）も同じ進め方
    key: '7名が7つのアプリを作り、2つが本番化へ',
    desc: 'AIとのアプリ開発実習で、システム開発の全体像と、発注者のスキルを学びました。7名が1人1つずつアプリを作り、そのうち2つを本番で使える形にする取り組みに、SALT2が伴走しています。',
    after: '次の取り組みのAIエージェント研修（新たに6名、広告・経理・データ分析など各自の実務がテーマ）も、同じ進め方で進めています。',
    voice: '「デモを見るだけの研修ではなく、実際に手を動かして作れた」',
    // 2026年4月は、A社との取り組み全体の始まり（2か月の研修・次の取り組み・本番化を含む）
    env: '同社のセキュリティ環境（Amazon Bedrock上のClaude）。A社との取り組みは2026年4月に開始し、いまも続いています',
  },
  'manufacturer-b': {
    id: 'manufacturer-b',
    name: '大手製造業B社',
    who: '東証プライム上場の製造業グループ',
    scope: '開発部門の6名・3か月',
    // 2026-10-20 代表の回答: 6名で6つの業務エージェントを、実際に使われるユースケースとして、リリースまで作り切る
    key: '6名で6つの業務エージェントの、リリースを目指す',
    desc: '一つひとつを、実際に使われるユースケースとしてリリースすることを目指して、いま進めています。ゴールは、研修のあともメンターなしで開発を続けられること。',
    steps: [
      { title: '要求の整理', desc: '業務の課題を整理し、AI駆動開発の進め方を学ぶ' },
      { title: '要件と画面', desc: '要件と画面を固め、報告会で確かめる' },
      { title: '実装と評価', desc: 'Claude Code で実装し、動く範囲を中間報告で見せる' },
      { title: '本番への接続', desc: '成果を発表し、本番環境への接続と引き継ぎまで進める' },
    ],
  },
  // 資料 p.18 の「大手商社C社」は、data/consulting.js の case-1（大手総合商社の営業部門）と同じ取り組み（2026-10-20 代表の回答）。
  // 1つの話として書く: 営業部門（約70名）、2026年7月の1か月・週2日の常駐、ご相談64件のうち40件に対応（その場で作った11件・
  // 作り方を助言した29件）（case-1）、繰り返す業務を Claude Code のスキルにしてチームに配る（資料 p.18）。
  // 内製化支援プログラムではなく常駐での支援（SALT2がその場で作ったものもある）なので、「関連する事例（常駐での支援）」と示し、
  // プログラムの事例としては並べない（LP の非エンジニアの欄からは外した。2026-10-20 確認の指摘）
  'trading-c': {
    id: 'trading-c',
    name: '大手総合商社',
    who: '東証プライム上場の総合商社',
    scope: '営業部門（約70名）・2026年7月の1か月、週2日の常駐',
    relation: '関連する事例（常駐での支援）',
    key: '「個人がチャットで使う」から、「組織にスキルがたまる」へ',
    desc: '2026年7月の1か月の支援で、繰り返す業務を Claude Code のスキルにし、うまくいったものをチームに配っています。週2日の常駐で、ご相談64件のうち40件に対応しました（その場で作ったものが11件、作り方を助言したものが29件）。',
    steps: [
      { title: '業務を洗い出す', desc: '資料作成・レポート・チェックなど、繰り返す業務を棚卸しする' },
      { title: 'スキルにする', desc: '目的・入力・出力を決め、Claude Code のスキルとして作る' },
      { title: '使って直す', desc: '実際の業務で使い、動作を確かめて直す' },
      { title: 'チームで共有', desc: 'うまくいったスキルを配り、組織のノウハウとしてためる' },
    ],
    // 同じ取り組みを、AIコンサルティング・開発の事例1（/cases/case-1）でも紹介している
    related: {
      text: 'この取り組みは、AIコンサルティング・開発の事例としても紹介しています。',
      to: '/cases/case-1',
      label: 'AIコンサルティング・開発の事例を見る',
    },
  },
};

// 3つの支援の形（資料 p.7）。使い分けは p.8 の注記、内製化支援プログラム（資料では「AIブートキャンプ」）の4つの型は p.10、
// 型ごとの期間と人数の例は提案テンプレート 01〜04 v0.4 の、AI駆動開発はプランA（3か月）、ほかの3つの型はプランB（2か月）。
// 2か月を主な例にする（2026-10-19 代表指示「1ヶ月もあるが、表示例は2ヶ月に」）。1か月の進め方は、ほかの進め方として案内する。
// 名前は「内製化支援プログラム」（2026-10-19 代表指示。個人向けの SALT2 Bootcamp と被るので「ブートキャンプ」と呼ばない）
export const programs = {
  label: 'Programs',
  ghost: 'PROGRAMS',
  title: [['3つの形で、'], ['支援します。']],
  lead: '体験から、現場での共同開発、選抜メンバーの集中育成まで。状況に合わせて組み合わせます。',
  items: [
    {
      key: 'workshop',
      no: '01',
      en: 'Workshop',
      name: 'ワークショップ',
      when: 'まず、体感したいときに',
      meta: '半日〜1日',
      desc: '自社の業務を題材に、手を動かして試します。',
      points: ['動くモックや、簡単な自動化までを体験する', '半日〜1日で、貴社の業務を題材に行います'],
    },
    {
      key: 'fde',
      no: '02',
      en: 'FDE Team',
      name: 'FDEチーム',
      when: '作るところまで、任せたいときに',
      meta: '現場に入り込むチーム',
      desc: 'SALT2のチームが現場に入り込み、一緒につくりながら、つくり方も伝えます。',
      points: ['業務で使うものを、一緒につくる', '体制と期間は、ご相談して決めます'],
    },
    {
      key: 'bootcamp',
      no: '03',
      en: 'Enablement Program',
      name: '内製化支援プログラム',
      when: '社内で、作れる人を育てたいときに',
      meta: '1〜3か月・選抜した少人数',
      // テンプレート v0.4 p.7（毎週3時間の枠: 講義1時間・ハンズオン2時間。代表指示で対面）・資料 p.7（研修のあとも PoC・本番化まで伴走）
      // 2026-10-20 代表指示: 作るのは貴社の方。SALT2のエンジニアはメンターとして伴走し、つまずいたところを一緒に解く
      desc: '毎週3時間（講義1時間・ハンズオン2時間）を対面で行い、全員が自分の業務をお題に作り切ることを目指します。お題は貴社の実際の業務で、作るのは貴社の方です。メンター（SALT2のエンジニア）が伴走し、つまずいたところを一緒に解きます。',
      // 2026-10-20 代表指示: 2つの成果を見えるように
      outcomes: [
        { label: '人が育つ', text: '研修のあとも、自分たちで作り続けられる人が育ちます。' },
        { label: '貴社の方が、ユースケースを実装まで進める', text: '研修と並行して、貴社の方が業務で使う前提でユースケースを作り、実装まで進めることを目指します。' },
      ],
      // 対象で2つに分かれる（代表指示: エンジニアと非エンジニアで対比して見せる）
      tracks: [
        {
          key: 'engineer',
          en: 'Engineer',
          jp: 'エンジニア',
          lead: '開発部門の方が、AI前提の進め方へ',
          types: [
            {
              id: 'bootcamp-dev',
              title: 'AI駆動開発ができる',
              desc: '要求から検証までを、AI前提の進め方で。Claude Code・Codex を、いまの開発フローに組み込む',
              example: '例：3か月・6名程度',
            },
          ],
          caseIds: ['manufacturer-b'],
        },
        {
          key: 'non-engineer',
          en: 'Non-Engineer',
          jp: '非エンジニア',
          lead: '業務を知る方が、AIで仕事を変える側へ',
          types: [
            {
              id: 'bootcamp-build',
              title: 'コーディングエージェントで、自分たちでつくれる',
              desc: 'Claude Code などで、身近な業務の自動化やアプリづくりに取り組む',
              // テンプレート 02 v0.4 のプランB（2か月・6名程度）
              example: '例：2か月・6名程度',
            },
            {
              id: 'bootcamp-vendor',
              // 資料 p.10（03）・テンプレート 03 v0.2（2026-10-20 代表指示: アプリを作る型とは別に、アプリを作らずに要件定義と
              // ベンダーコントロールができるようになる型として戻す）。例はプランB（2か月・6名程度）
              title: '要件定義と発注を、自分たちで進められる',
              desc: 'アプリを作るのではなく、モックまで自分でつくって要件を固め、RFPを書き、発注と評価を進める',
              example: '例：2か月・6名程度',
            },
            {
              id: 'bootcamp-efficiency',
              title: 'いま使っているAIで、仕事を効率化できる',
              desc: 'Copilot や Claude など、社内で認められたAIを日々の仕事で使いこなす',
              example: '例：2か月・10名程度',
            },
          ],
          caseIds: ['maker-a'],
        },
      ],
      note: '企業ごとに設計する、法人向けのプログラムです。',
    },
  ],
};

// 始め方（資料 p.23）。料金は載せず、資料とお打ち合わせで説明する（2026-10-20 代表指示）
export const start = {
  label: 'Getting Started',
  ghost: 'START',
  title: [['まずは、'], ['無料の', 'ご相談から。']],
  steps: [
    // 2026-11-05 代表の決定: 無償・無料で提供するのはご相談と資料だけ。トライアル・ワークショップ・案件は有償
    { title: 'ご相談', desc: '現状と目的を伺い、出発点を決めます', badge: '無料' },
    { title: 'ワークショップ', desc: '任意です。半日〜1日、手を動かして体感します' },
    { title: '設計・お見積もり', desc: '育てたい人・作りたいもの・期間から組みます' },
    { title: 'キックオフ', desc: 'ご相談から、最短1か月で始められます' },
  ],
};

// 締めくくり
export const closing = {
  en: ['BUILD AI', 'IN-HOUSE.'],
  // 2026-10-20 代表指示: 料金は載せず、資料とお打ち合わせで説明する
  text: '支援の形、プログラムの進め方、事例は、資料でご案内しています。費用は、資料とお打ち合わせでご説明します。',
  cta: '資料請求',
};

// 資料請求のフォーム（/documents/enablement。src/data/documentRequests.js）の「関心のあること」の選択肢
export const request = {
  interests: [
    'ワークショップ',
    'FDEチーム',
    '内製化支援プログラム',
    '人材開発支援助成金の活用',
    'まずは相談したい',
  ],
};
